<template>
  <li class="daiei-flyer-card">
    <intersection-observer
      class="module-card-intersection-observer"
      tag-type="a"
      :href="hrefValue"
      :active="true"
      @intersect="emitIntersect"
      @click.native="emitClick"
    >
      <figure v-if="image" class="daiei-flyer-card__image">
        <extended-image
          :src="image"
          css-width="100%"
          css-height="100%"
          object-fit="cover"
        />
      </figure>
      <div
        v-if="dateText || issue"
        class="daiei-flyer-card__text c-page-shop__flyer-text"
      >
        <p
          v-if="dateText"
          class="daiei-flyer-card__date c-page-shop__flyer-date"
        >
          {{ dateText }}
        </p>
        <p v-if="issue" class="daiei-flyer-card__issue">{{ issue }}</p>
      </div>
      <!-- <div @click="emitClick">
      </div> -->
    </intersection-observer>
  </li>
</template>

<script setup>
import ExtendedImage from '@/components/ExtendedImage'
import IntersectionObserver from '@/components/IntersectionObserver'

const runtimeConfig = useRuntimeConfig()

const props = defineProps({
  /**
   * 記事ID
   */
    id: {
    type: Number,
    required: true,
  },
  /**
   * 画像用データ
   */
  image: {
    type: String,
    required: true,
  },
  /**
   * 日付
   * {array} unix timeでくる想定
   */
  date: {
    type: Array,
    default: () => [],
  },
  /**
   * 号
   */
  issue: {
    type: String,
    default: null,
  },
  shopId: {
    type: [Number, String, null],
    default: null,
  },
  detailId: {
    type: [Number, String],
    required: true,
  },
  location: {
    type: Object,
    default: null,
  },
  utmSource: {
    type: [Number, String, null],
    default: null,
  },
})

const emit = defineEmits(['click', 'intersect'])

const dateText = computed(() => {
  if (1 in props.date) {
    if (FORMATBY(props.date[0], 'YYYY') !== FORMATBY(props.date[1], 'YYYY')) {
      return `${FORMATBY(ADDDAY(props.date[0]), 'YYYY年M月D日')}~${FORMATBY(
        props.date[1],
        'YYYY年M月D日'
      )}まで`
    } else if (
      FORMATBY(ADDDAY(props.date[0]), 'M') !== FORMATBY(props.date[1], 'M')
    ) {
      return `${FORMATBY(ADDDAY(props.date[0]), 'YYYY年M月D日')}~${FORMATBY(
        props.date[1],
        'M月D日'
      )}まで`
    } else {
      return `${FORMATBY(ADDDAY(props.date[0]), 'YYYY年M月D日')}~${FORMATBY(
        props.date[1],
        'D日'
      )}まで`
    }
  } else if (0 in props.date) {
    return `${FORMATBY(props.date[0], 'YYYY年M月D日')}まで`
  } else {
    return null
  }
})

const hrefValue = computed(() => {
  // TODO URLは要検討
  if (props.utmSource) {
    return `${runtimeConfig.public.chirashiUrl}/${runtimeConfig.public.chainKey}/${runtimeConfig.public.paddingedChainId}/chirashi/?shop-id=${props.shopId}&detail-id=${props.detailId}&utm_source=${props.utmSource}`
  } else {
    return `${runtimeConfig.public.chirashiUrl}/${runtimeConfig.public.chainKey}/${runtimeConfig.public.paddingedChainId}/chirashi/?shop-id=${props.shopId}&detail-id=${props.detailId}`
  }
})

const emitClick = (e) => {
  e.preventDefault()
  emit('click', { link: hrefValue.value })
  return false
}

const emitIntersect = () => {
  const data = {
    id: props.id,
    detailId: props.detailId,
    shopId: props.shopId,
    location: JSON.stringify(props.location),
  }
  emit('intersect', data)
}
</script>

<style lang="scss" scoped>
.daiei-flyer-card {
  width: 464px;
  width: calc(464 / 960 * 100%);
  margin-bottom: 32px;
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 3.33333vw;
  }

  .daiei-flyer-card__image {
    width: 177px;
    height: 118px;
    overflow: hidden;

    @media screen and (max-width: 767px) {
      width: 31.66667vw;
      height: calc(31.66667vw * (2 / 3));
    }

    > img {
      max-width: 100%;
      -webkit-transition: -webkit-transform 300ms;
      transition: -webkit-transform 300ms;
      transition: transform 300ms;
      transition: transform 300ms, -webkit-transform 300ms;
      object-position: top;
    }
  }

  .daiei-flyer-card__text {
    padding-left: 25px;
    letter-spacing: 0.13em;
    width: calc(100% - 145px);

    @media screen and (max-width: 767px) {
      padding-left: 5vw;
      width: calc(100% - 36.66667vw);
    }
  }

  .daiei-flyer-card__date {
    font-weight: bold;
  }

  .daiei-flyer-card__issue {
    padding-top: 5px;
  }

  > a {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    text-decoration: none;
    font-size: 14px;
    line-height: 1.7;
    -webkit-transition: opacity 300ms;
    transition: opacity 300ms;
    font-feature-settings: 'palt';
    color: #000;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      opacity: 0.6;
      img {
        transform: scale(1.1);
      }
    }

    @media screen and (max-width: 767px) {
      border-radius: 1.66667vw;
      font-size: 3.88889vw;
      &:hover {
        opacity: 1;
        img {
          transform: scale(1);
        }
      }
    }
  }

  > p {
    margin: 0;
  }
}
</style>
